import { adminManagementApi } from "@/lib/api"
import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query"

const useDeleteAdmin = (options?: UseMutationOptions<unknown, Error, string>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (adminId: string) => {
      try {
        const response = await adminManagementApi.deleteAdmin(adminId)
        return response.data
      } catch (error: unknown) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error as { response?: { data?: { message?: string } } }
          if (err.response?.data?.message) {
            throw new Error(err.response.data.message)
          }
        }
        throw error
      }
    },
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: ["admins"] })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}

export default useDeleteAdmin
